import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { userLst } from 'src/app/models/userLst';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { CreateEditDeportistaComponent } from '../create-edit-deportista/create-edit-deportista.component';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EditDisciplinaUserComponent } from './edit-disciplina-user/edit-disciplina-user.component';
import { EditHorariosDeportistaComponent } from './edit-horarios-deportista/edit-horarios-deportista.component';
import { ModalQrComponent } from '../../varios/modal-qr/modal-qr.component';
import { EditDetalleUsuariosComponent } from '../edit-detalle-usuarios/edit-detalle-usuarios.component';
import { CambioPlanComponent } from './cambio-plan/cambio-plan.component';
import { ActualizaFotoUsuarioComponent } from './actualiza-foto-usuario/actualiza-foto-usuario.component';
import { HistorialIngresosUsuarioComponent } from '../historial-ingresos-usuario/historial-ingresos-usuario.component';
import { ListadoQrsComponent } from './listado-qrs/listado-qrs.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ExtencionService } from 'src/app/services/extencion.service';
import { AddExtencionComponent } from './add-extencion/add-extencion.component';
import { PlanService } from 'src/app/services/plan.service';
import { ModalListadoExtencionesComponent } from './modal-listado-extenciones/modal-listado-extenciones.component';
import { ModalListadoOrdenesCompraUsuarioComponent } from './modal-listado-ordenes-compra-usuario/modal-listado-ordenes-compra-usuario.component';

@Component({
  selector: 'app-index-deportistas',
  templateUrl: './index-deportistas.component.html',
  styleUrls: ['./index-deportistas.component.scss'],
})
export class IndexDeportistasComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  permiteExtencion = false;
  searchString: string = '';
  public lstDisciplinas: any;
  public lstPlanes: any;
  public lstDeportistas: userLst[];
  public disciplinaSelect: any;
  public ordenamientoSelect = '0';
  public hoy = new Date();


  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    public disciplinaSvc: DisciplinaService,
    private planSvc: PlanService,
    public extencionSvc: ExtencionService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: userLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'plan',
      'fechaFin',
      'estado',
      'altoRendimiento',
      'botones',
    ];

    this.dataSource = new MatTableDataSource<userLst>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;
      this.getUsers(0, 10);
    });
  }

  ngOnInit(): void {
    this.planSvc.GetPlanesDropDown().subscribe((disLst) => {
      console.log(disLst);
      this.lstPlanes = disLst;
    });

    this.extencionSvc.permiteExtencionesServicios().subscribe((result) => {
      this.permiteExtencion = result;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistas(
        page,
        numReg,
        this.searchString,
        this.ordenamientoSelect,
        this.disciplinaSelect
      )
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<userLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.lstDeportistas = result[0];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  openDialogCreateUser(): void {
    let dialogRef = this.dialog.open(CreateEditDeportistaComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  edit(obj: any) {
  //  console.log(obj);

    let dialogRef = this.dialog.open(CreateEditDeportistaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
          this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  editDisciplina(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(EditDisciplinaUserComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  cambioDisciplina(disciplinaId: any, deportista: any) {
    /*     console.log('disciplinaId: ', disciplinaId);
    console.log('deportista: ', deportista);
 */
    this.userSvc
      .editarDisciplinaUsuario({ id: deportista.id, disciplinaId })
      .subscribe((res) => {
        console.log('resultado EditarDisciplina: ', res);
        if (res) {
          this.alertify.success('Usuario actualizado');
        } else {
          this.alertify.error('La disciplina no se ha podido actualizar');
        }
      });
  }

  delete(obj: any) {
    console.log(obj);
    this.alertify.confirm('Confirma que quiere eliminar el usuario?', () => {
      this.userSvc.EliminarUsuario(obj).subscribe((res) => {
        if (res) {
          this.getUsers(this.pageIndex, this.pageSize);
          this.alertify.success('Usuario eliminado correctamente.');
        } else {
          this.alertify.error('El usuario no se ha podido eliminar.');
        }
      });
    });
  }

  cambioDiscipinaBuscar() {
    this.getUsers(this.pageIndex, this.pageSize);
  }

  editHorariosUsuario(obj: any) {
    console.log(obj);
    obj.filtroEmpresa = true;
    let dialogRef = this.dialog.open(EditHorariosDeportistaComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getUsers(this.pageIndex, this.pageSize);
      }
    });
  }

  cambioPlan(planId: any, deportista: any) {
    console.log(planId);
    this.userSvc
      .editarPlanDeUsuario({ planId, usuarioId: deportista.id })
      .subscribe((res) => {
        console.log('resultado EditarPlan: ', res);
        if (res) {
          this.alertify.success('Plan actualizad ');
        } else {
          this.alertify.error('El plan no se ha podido actualizar');
        }
      });
  }

  descargarQr(obj: any) {
    console.log(obj);
    let dialogRef = this.dialog.open(ModalQrComponent, {
      data: {qr:obj.qr, nombre:obj.nombre},
      panelClass: 'modal-qr-panel',
    });
  }

  openDialogEditDetalle(obj: any): void {
    let dialogRef = this.dialog.open(EditDetalleUsuariosComponent, {
      data: obj,
    });
  }

  fotoUsuario(usr: any) {
    let dialogRef = this.dialog.open(ActualizaFotoUsuarioComponent, {
      data: usr,
    });
  }

  openDialogHistorialIngresos(usr: any) {
    let dialogRef = this.dialog.open(HistorialIngresosUsuarioComponent, {
      data: usr,
    });
  }

  ordenesCompraUsuario(usr:any){
    let dialogRef = this.dialog.open(ModalListadoOrdenesCompraUsuarioComponent, {
      data: usr,
    });
  }

  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

    this.userSvc
      .updateEstadoUsuario(elemento.id, ob.checked)
      .subscribe((result) => {
        if (result) {
          elemento.estado = ob.checked;
          this.alertify.success('Estado actualizado');
        } else {
          this.alertify.error('Error al actualizar el estado');
          console.log('error al cambiar de estado');
        }
      });
  }

  onToggleAltoRendimiento(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

    this.userSvc
      .updateEstadoAltorendimiento(elemento.id, ob.checked)
      .subscribe((result) => {
        if (result) {
          elemento.altoRendimiento = ob.checked;
          this.alertify.success('Estado actualizado');
        } else {
          this.alertify.error('Error al actualizar el estado');
          console.log('error al cambiar de estado');
        }
      });
  }

  asignarIngresoExtraordinario(usr: any) {
    this.alertify.confirm(
      'Confirma asignar un ingreso extraordinario a este usuario?',
      () => {
        this.userSvc.setIngresoExtraordinario(usr.id).subscribe((result) => {
          if (result) {
            this.alertify.success('Se ha asignado el ingreso extraordinario');
          } else {
            this.alertify.error('Error al asignar el ingreso extraordinario');
          }
        });
      }
    );
  }

  openDialogQrsDeportistas(): void {
    let dialogRef = this.dialog.open(ListadoQrsComponent, {
      data: this.lstDeportistas,
    });
  }

  extenderServicio(usr: any) {
    let dialogRef = this.dialog.open(AddExtencionComponent, {
      data: usr,
    });
  }

  extencionesUsuario(usr:any){
    let dialogRef = this.dialog.open(ModalListadoExtencionesComponent, {
      data: usr,
    });
  }

  validarFechas(fecha: any): boolean {
    return Date.parse(fecha) >= this.hoy.getTime();
  }

  descargarReporte() {
    this.userSvc.DownloadDeportistas().subscribe((result) => {
      console.log('result: ', result);
      let blob = new Blob([result], { type: 'application/vnd.ms-excel' });
      var downloadURL = window.URL.createObjectURL(result);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download =  'deportistas' + '.xlsx';
      link.click();
    });
  }
}
